import React from 'react'
import routes from '../router';
function DecodeRoutes({ obj }){
    var elements;
        if (typeof(obj.element) != "undefined"){
            if(obj.path==="*"){
                elements=<></>
            }else if(obj.path===""){
                elements=<li>[home]</li>
            }else{
                elements=<li>{obj.path}</li>
            }
        } else {
            elements=<li>{obj.path}<ul>{obj?.children?.map((obj,i)=><DecodeRoutes key={i} obj={obj} />)}</ul></li>
        }
        return elements;
}
function SiteMap() {
  return (
    <div>
        <h1>SiteMap</h1>
        <ul>{routes.map((obj,i)=><DecodeRoutes obj={obj} key={i} />)}</ul>
    </div>
  )
}

export default SiteMap;